import DateFnsUtils from '@date-io/date-fns';
import {
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';

export default function SelectSessionDateTime({
  selectedDateTime,
  setSelectedDateTime,
}) {
  return (
    <div className='mt-4'>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDateTimePicker
          onChange={setSelectedDateTime}
          value={selectedDateTime}
          format='dd-MMM-yy hh:mm'
          inputVariant='outlined'
          className='max-w-md w-full'
          disablePast
        />
      </MuiPickersUtilsProvider>
    </div>
  );
}
